import React from 'react';
import { View } from 'react-native';
import { moderateScale } from '../Utils/Scaling';
import { color as baseColor } from '../Styles/Base';
var ListDivider = function (_a) {
    var style = _a.style, _b = _a.color, color = _b === void 0 ? baseColor.gallery : _b, _c = _a.width, width = _c === void 0 ? moderateScale(2) : _c;
    return React.createElement(View, { style: [{ borderBottomWidth: width, borderBottomColor: color }, style] });
};
export default ListDivider;
